import { StyleSheet } from 'react-native';

import { i18n } from '@/utils/i18n';

import LightRatingButton from '../buttons/LightRatingButton';
import Card from '../Card';
import Text from '../Text';

const ExplanationCard = () => {
  const description = i18n.t('light_rating_explanation.description');

  return (
    <Card style={styles.cardStyle} disabled>
      <LightRatingButton variant="large" lightRatingValue={8.75} disabled />
      <Text fontWeight="700" style={styles.description}>
        {description}
      </Text>
    </Card>
  );
};

const styles = StyleSheet.create({
  lightRatingMainContainer: {
    zIndex: 1
  },

  lightRatingContent: {
    flexDirection: 'column',
    alignItems: 'center'
  },

  lightRatingFlameIcon: {
    height: 75,
    width: 75,
    zIndex: 3
  },

  cardStyle: {
    flexDirection: 'row',
    width: '100%',
    padding: 25,
    gap: 15
  },

  description: {
    flex: 1,
    flexWrap: 'wrap',
    color: 'black'
  }
});

export default ExplanationCard;
